import React, { Component } from 'react';
import Header from '../../common/Header/Header';
import { Modal } from '@material-ui/core';
import VideoComponent from '../../common/VideoComponent';
import Close from '@material-ui/icons/Close';
import Footer from '../../common/Footer/Footer';
import FooterMobile from './LandingComponents/FooterMobile_2';
import ReadyToGetStarted from '../../common/ReadyToGetStarted';
import * as GlobalActions from '../../reducers/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import view from '../../Enums';
import LandingImage from './LandingComponents/LandingImage';
import OyoStats from './LandingComponents/OyoStats';
import WhyJoinOyo from './LandingComponents/WhyJoinOyo';
import OyoOSmodule from './LandingComponents/OyoOSmodule';
import StepsToPartner from './LandingComponents/StepsToPartner';
import WhatPartnersSay from './LandingComponents/WhatPartnersSay';
import PeopleCheckIntoOyo2 from './LandingSubComponents/PeopleCheckIntoOyo2';
import BecomeAnOyoForm3 from './LandingComponents/BecomeAnOyoForm3';
import { guc as localGuc } from '../../services/Localisation';
import {
  AssetTransformation,
  AssetTransformationMobile,
  close_button,
  close_buttonMobile,
  editErrorModal,
  editErrorModal_heading,
  editErrorModal_headingMobile,
  editErrorModal_headingVideo,
  editErrorModalMobile,
  FinancialSupport,
  FinancialSupportMobile,
  FinancialSupportTo,
  FinancialSupportToMobile,
  KnowMoreContent,
  KnowMoreContentMobile,
  OYOTeamComesToMe,
  OYOTeamComesToMeMobile,
  Step1,
  Step1Mobile
} from '../../partnerStyles';
import KnowMoreModal2 from './LandingComponents/KnowMoreModal2';
import { hmsSelfOnboardingEnabled, selfOnboardingEnabled } from '../../config/countryConfig';
import { GrowTransition } from '../../ui-components/utils';
import IconButton from '../../ui-components/Button/Icon';
import { CloseRounded } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog/Dialog';

class LandingPageRender extends Component {
  state = {
    hide_join_us: true
  };

  componentDidUpdate(prevProps, prevState, snapshot) {}
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {

    let gc = this.props.gc;
    let guc = this.props.guc;
    let gi = this.props.gi;
    let gs = this.props.gs;

    let modalStyle, headerStyle, contentStyle, closeButtonStyle;

    if (this.props.viewMode == view.DESKTOP) {
      modalStyle = [editErrorModal, editErrorModal];

      headerStyle = [
        Step1,
        FinancialSupport,
        editErrorModal_heading,
        editErrorModal_headingVideo
      ];

      contentStyle = [
        AssetTransformation,
        OYOTeamComesToMe,
        FinancialSupportTo,
        KnowMoreContent
      ];

      closeButtonStyle = close_button;
    } else {
      modalStyle = [
        editErrorModalMobile,
        { ...editErrorModalMobile, width: '97%' }
      ];

      headerStyle = [
        Step1Mobile,
        FinancialSupportMobile,
        editErrorModal_headingMobile,
        editErrorModal_headingVideo
      ];

      contentStyle = [
        AssetTransformationMobile,
        OYOTeamComesToMeMobile,
        FinancialSupportToMobile,
        KnowMoreContentMobile
      ];

      closeButtonStyle = close_buttonMobile;
    }

    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && this.props.viewMode && (
          <div ref={this.props.setParentRef} id = "landingPageParent" style={gs('complete_div_style')} onScroll={this.props.scrollListener}>
            <Header
              handleScrollToForm={this.props.handleScrollToForm}
              viewMode={this.props.viewMode}
              data={this.props.globalData.universal_translations}
              handleOnClick={this.props.handleOnClick}
              handleOnClickProgram={this.props.handleOnClickProgram}
              show_right_options={true}
              globalActions={this.props.globalActions}
              headerTop={this.props.headerTop}
              guc={guc}
              changeOyoForm={this.props.changeOyoForm}
              headerAppeared={this.props.headerAppeared}
              countryIsoCode={this.props.globalData.country_iso_code}
              redirectToHms={this.props.redirectToHms}
              gs={gs}
            />

            <div style={{ width: '100%' }}></div>

            <LandingImage
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              showMessageModal={this.props.showMessageModal}
              landingImageHeight={this.props.landingImageHeight}
              viewMode={this.props.viewMode}
              rightMarginForForm={this.props.rightMarginForForm}
              borderTopBecomeOyoForm={this.props.borderTopBecomeOyoForm}
              becomeOyoFormHeight={this.props.becomeOyoFormHeight}
              landingImageLoad={this.props.landingImageLoad}
              amount={this.props.amount}
              highLightForm={this.props.highLightForm}
              giveAbilityToChangeOyoForm={this.props.giveAbilityToChangeOyoForm}
              changeOyoForm={this.props.changeOyoForm}
              handleScrollToForm={this.props.handleScrollToForm}
              utm_data={this.props.state.utm_data}
              redirectToHms={this.props.redirectToHms}
              additionalHeaderStyles={this.props.additionalHeaderStyles}
            />
  
            {!selfOnboardingEnabled() && <BecomeAnOyoForm3
                viewMode={this.props.viewMode}
                rightMarginForForm={this.props.rightMarginForForm}
                borderTopBecomeOyoForm={this.props.borderTopBecomeOyoForm}
                becomeOyoFormHeight={this.props.becomeOyoFormHeight}
                becomeOyoFormExtraHeight={this.props.becomeOyoFormExtraHeight}
                amount={this.props.amount}
                highLightForm={this.props.highLightForm}
                utm_data={this.props.state.utm_data}
            />}

            {this.props.viewMode == view.MOBILE && (
              <div
                style={{
                  height: this.props.becomeOyoFormExtraHeight + (selfOnboardingEnabled()?200:280) + 'px'
                }}
              ></div>
            )}

            <OyoStats
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              viewMode={this.props.viewMode} />
            {localGuc('testimonials_enabled','true') === 'true' && localGuc('emailBecomeAnOyoForm3Enabled',false) && <WhatPartnersSay
                gc = {gc}
                guc = {guc}
                gs = {gs}
                gi = {gi}
                setHearFromPartnersRef={this.props.setHearFromPartnersRef}
                handleOpenVideoModal={this.props.handleOpenVideoModal}
                viewMode={this.props.viewMode}
            />}

            <WhyJoinOyo
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              viewMode={this.props.viewMode}
              setWhyOyo2Ref={this.props.setWhyOyo2Ref}
              hideWhyOyo={this.props.hideWhyOyo}
              link={this.props.link}
            />

            <OyoOSmodule
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              viewMode={this.props.viewMode}
              setOpmsRef={this.props.setOpmsRef}
              handleOpenVideoModal={this.props.handleOpenVideoModal}
              changeOyoOsModuleStyle={this.props.changeOyoOsModuleStyle}
            />

            {!hmsSelfOnboardingEnabled() && <StepsToPartner
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              viewMode={this.props.viewMode}
              setStepsToPartnerRef={this.props.setStepsToPartnerRef}
            />}

            {this.props.viewMode == view.MOBILE && this.props.state.mobileLandingCarouselList?  this.props.renderMobileCarousel() : (this.props.state.landingCarouselList ? this.props.renderCarousel() : <PeopleCheckIntoOyo2
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              mobileVsmall={this.props.mobileVsmall}
              handleScrollToForm={this.props.handleScrollToForm}
              viewMode={this.props.viewMode}
              setPeopleCheckInRef={this.props.setPeopleCheckInRef}
              redirectToHms={this.props.redirectToHms}
            />)}
            
            {localGuc('testimonials_enabled','true') === 'true' && !localGuc('emailBecomeAnOyoForm3Enabled',false) && <WhatPartnersSay
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              setHearFromPartnersRef={this.props.setHearFromPartnersRef}
              handleOpenVideoModal={this.props.handleOpenVideoModal}
              viewMode={this.props.viewMode}
            />}

            <ReadyToGetStarted
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              setReadyRef={this.props.setReadyRef}
              viewMode={this.props.viewMode}
              handleScrollToForm={this.props.handleScrollToForm}
              redirectToHms={this.props.redirectToHms}
            />

            {this.props.viewMode == view.DESKTOP && (
              <Footer
                viewMode={this.state.viewMode}
                getImage={gi}
                getStyle={gs}
                getContent={gc}
                getUniversalContent={guc}
                setFooterRef={this.props.setFooterRef}
              />
            )}

            {this.props.viewMode == view.MOBILE && (
              <FooterMobile
                gc = {gc}
                guc = {guc}
                gs = {gs}
                gi = {gi}
                viewMode={this.props.viewMode}
                setFooterRef={this.props.setFooterRef}
              />
            )}

            {/*modals*/}

            {/*KnowMore*/}
            {this.props.state.showModal && (
              <Modal
                open={this.props.state.showModal}
                onClose={this.props.handleCloseModalKnowMore}
              >
                <KnowMoreModal2
                  viewMode={this.props.viewMode}
                  head={this.props.header}
                  fullContent={this.props.fullContent}
                  imgSrc={this.props.imgKnowMore}
                  getStyle={gs}
                  getContent={gc}
                  getImage={gi}
                  onClose={this.props.handleCloseModalKnowMore}
                />
              </Modal>
            )}

            {/*video  modal*/}
            {this.props.state.showVideoModal && (
              <Modal
                open={this.props.state.showVideoModal}
                onClose={this.props.handleCloseVideoModal}
              >
                <div style={modalStyle[1]} className={'mobile'}>
                  <div style={headerStyle[3]}>
                    {this.props.state.header}
                    <div style={{ ...close_button, margin: '0' }}>
                      <Close onClick={this.props.handleCloseVideoModal} />
                    </div>
                  </div>
                  <div>
                    <VideoComponent youtubeId={this.props.state.youtubeId} />
                  </div>
                </div>
              </Modal>
            )}
  
            <Dialog maxWidth='sm' open={this.props.state.showMessageModal} TransitionComponent={GrowTransition} onClose={() => this.props.fMessageModal(false)}>
              <div style={gs('dialog_header')}>
                <div style={gs('dialog_title')}>{guc('congratulations')}{'!!'}</div>
                <IconButton onClick={() => this.props.fMessageModal(false)}><CloseRounded /></IconButton>
              </div>
              <div style={gs('dialog_content')}>
                {guc('an_oyo_representative')}
              </div>
            </Dialog >

            
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageRender);

/*
Individual components:
Type of property Card (with an id and selected state id)

*/
